import { render, staticRenderFns } from "./FormSetupEdit.vue?vue&type=template&id=06905d82"
import script from "./FormSetupEdit.vue?vue&type=script&lang=js"
export * from "./FormSetupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports